<template>
  <div class="login_container">
    <div class="login_box">
      <h1>晨星综合管理系统</h1>
      <el-form ref="loginFormRef" :model="loginData" :rules="loginFormRules">
        <el-form-item prop="username">
          <el-input v-model="loginData.username" autocomplete="off" prefix-icon="iconfont icon-iconzh"> </el-input>
        </el-form-item>
        <el-form-item prop="password" class="password">
          <el-input type="password" v-model="loginData.password" autocomplete="off" prefix-icon="iconfont icon-mima" @keyup.enter.native="login"> </el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px">
          <el-button class="submit" type="primary" @click="login()">登录</el-button>
        </el-form-item>
      </el-form>
      <p class="capyright">版本：V3.0　　设计和维护：晨星科技版权所有</p>
    </div>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import { login } from '@/api/login'
  export default {
    data() {
      return {
        loginData: {
          username: '',
          password: '',
        },
        // 表单验证规则
        loginFormRules: {
          username: [
            {
              required: true,
              message: '请输入用户名',
              trigger: 'blur',
            },
            {
              min: 3,
              max: 20,
              message: '长度在 3 到 2 个字符',
              trigger: 'blur',
            },
          ],
          password: [
            {
              required: true,
              message: '请输入密码',
              trigger: 'blur',
            },
            {
              min: 6,
              max: 15,
              message: '长度在 6 到 15 个字符',
              trigger: 'blur',
            },
          ],
        },
      }
    },
    methods: {
      async login() {
        this.$refs.loginFormRef.validate(async (vali) => {
          // 如果验证不通过则中断函数
          if (!vali) return
          // 拷贝登录信息数据
          let loginData = Object.assign({}, this.loginData)
          loginData.password = md5(this.loginData.password)
          let res = await login(loginData)
          if (res.status !== 200) {
            this.$message.error('登录失败，账号或密码错误')
          } else {
            this.$message.success('登录成功')
            // 将用户信息存入缓存中
            sessionStorage.setItem('userInfo', JSON.stringify(res.userInfo))
            this.$store.dispatch('user/SET_USERINFO', res.userInfo)
            // 跳转首页
            this.$router.push('/')
          }
        })
      },
    },
  }
</script>

<style lang="less">
  .login_container {
    height: 100vh;
    overflow: hidden;
    background: url(../assets/images/loginbg_01.jpg) no-repeat center center fixed;
    background-size: cover;
    .login_box {
      width: 440px;
      height: 380px;
      background-color: rgba(255, 255, 255, 0.5);
      border-radius: 20px;
      box-shadow: 0px 2px 10px 0px rgba(34, 27, 28, 0.5);
      margin: 0 auto;
      margin-top: 10%;

      h1 {
        text-align: center;
        font-weight: 300;
        font-size: 35px;
        color: #323232;
        padding-top: 25px;
        margin-bottom: 20px;
      }
      .el-form {
        padding: 0 40px;
        .password {
          margin-bottom: 25px;
        }
        .el-form-item__content {
          line-height: 0;
        }
        .rememb {
          margin-top: -10px;
        }
        .el-input {
          width: 360px;
          overflow: hidden;
          .iconfont {
            line-height: 53px;
            font-size: 28px;
            padding-left: 6px;
          }
          input {
            outline: none;
            height: 100%;
            height: 58px;
            border-radius: 8px !important;
            border-color: #c0c0c0;
            font-size: 20px;
            padding-left: 45px;
            font-weight: 200;
            line-height: 50px;
          }
        }
        .submit {
          width: 360px;
          height: 54px;
          color: #fff;
          font-size: 22px;
          background-color: #2887d4;
        }
      }
      .capyright {
        text-align: center;
        color: #b3b3b3;
        font-size: 16px;
        font-weight: 200;
      }
    }
  }
</style>
